"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var shouldRenderContent = function shouldRenderContent(content) {
  if (content) {
    return content;
  }
  return '';
};
var _default = shouldRenderContent;
exports["default"] = _default;